import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"

function SEO({ description, keywords, image, title }) {
  const location = useLocation()
  const hebrew = location.pathname.startsWith("/he") ? true : false

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            image
          }
        }
      }
    `
  )
  const metaDescription = description || site.siteMetadata.description
  const metaImage = image || site.siteMetadata.image

  const metaLang = hebrew ? "he" : "en"
  const metaTitle = hebrew ? `איתי שיף | Full Stack Developer` : site.siteMetadata.title
  const metaAuthor = hebrew ? `איתי שיף` : site.siteMetadata.author
  const metaLocale = hebrew ? "he-IL" : "en_US"

  const defaultKeywordsEN = ["Itay Shiff", "Portfolio", "Full Stack Developer", "Web Developer", "ReactJS Developer", "GatsbyJS"]
  const defaultKeywordsHE = ["איתי שיף", "פורטפוליו", "מפתח פרונד אנד", "מפתח צד לקוח", "בניית אתרים", "ReactJS מפתח", "GatsbyJS"]
  function getProperKeywords(keywords) {
    if (hebrew) {
      return keywords ? keywords.concat(defaultKeywordsHE) : defaultKeywordsHE
    } else {
      return keywords ? keywords.concat(defaultKeywordsEN) : defaultKeywordsEN
    }
  }
  const metaKeywords = getProperKeywords(keywords)

  return (
    <Helmet
      htmlAttributes={{
        lang: metaLang,
      }}
      title={title}
      titleTemplate={`%s ${metaTitle}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: metaImage,
        },
        {
          property: `og:locale`,
          content: metaLocale,
        },
        {
          property: `og:site_name`,
          content: metaTitle,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:creator`,
          content: metaAuthor,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: metaImage,
        },
        {
          name: `keywords`,
          content: metaKeywords.join(`, `),
        },
      ].concat([])}
    />
  )
}

export default SEO
